import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "stars"
const StarsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.811 2.203 2.21 4.1 4.042 2.229-4.042 2.227-2.21 4.102-2.21-4.102-4.067-2.227 4.068-2.228 2.21-4.101Zm2.938 13.721 1.054 1.924 1.909 1.038-1.909 1.063-1.054 1.924-1.03-1.924-1.908-1.063 1.909-1.038 1.029-1.924Zm7.382-4.886-1.406-2.582-1.381 2.582-2.536 1.392 2.536 1.393 1.38 2.582 1.407-2.582 2.536-1.393-2.536-1.392Z"
      />
    </svg>
  )
}
export default StarsIcon
